import { Injectable } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { ButtonType, DialogType, ModalDialogService } from '@frontend/sports/modal/feature';

@Injectable({ providedIn: 'root' })
export class PrintErrorDialogService {
    constructor(
        private modalDialogService: ModalDialogService,
        private sitecore: Sitecore,
    ) {}

    show(): Promise<ButtonType> {
        const modal = this.modalDialogService.openMessage({
            type: DialogType.Warning,
            title: this.sitecore.myBets_Print.ErrorDialogTitle,
            firstParagraph: this.sitecore.myBets_Print.ErrorDialogMessage,
            buttons: [
                {
                    text: this.sitecore.myBets_Print.ErrorDialogButtonText,
                    type: ButtonType.Cancel,
                    cssClass: '',
                },
            ],
        });

        return modal.result;
    }
}
